import { Button, Grid, TextField, Typography, useTheme } from "@mui/material";

import { AddEditBankAccountSchema } from "utils/validations/AddEditBankAccountSchema";
import { BankAccountEdit } from "store/api/BankAccounts";
import { LoadingButton } from "@mui/lab";
import Select from "components/Select";
import TextMask from "react-text-mask";
import http from "config/http";
import { useForm } from "react-hook-form";
import useNotify from "hooks/useNotify";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

const CREDIT_CARD_MASK = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const SHEBA_MASK = [
  "I",
  "R",
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
];

function AddEditBankAccountForm({
  onClose,
  bankDataForm,
  getBankAccountList,
  selectedBankAccount,
}) {
  const theme = useTheme()
  const notify = useNotify();

  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AddEditBankAccountSchema()),
    defaultValues: {
      bankId: selectedBankAccount?.bankId || "",
      accountOwnerName: selectedBankAccount?.accountOwnerName || "",
      accountNumber: selectedBankAccount?.accountNumber || "",
      shabaNumber: selectedBankAccount?.shabaNumber || "",
      cardNumber: selectedBankAccount?.cardNumber || "",
    },
  });

  const isEdit = selectedBankAccount;

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      if (isEdit) {
        await http.post(BankAccountEdit, {
          ...data,
          id: selectedBankAccount?.id,
        });
      } else {
        await http.post(BankAccountEdit, {
          ...data,
          cardNumber: data?.cardNumber
            .replace(/\s/g, "")
            .replaceAll("_", "")
            .replaceAll("-", ""),
          shabaNumber: data?.shabaNumber
            .replace(/\s/g, "")
            .replaceAll("_", "")
            .replaceAll("-", ""),
          id: -1,
        });
      }
      getBankAccountList();
      onClose();
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }

    setLoading(false);
  };

  const handleChangeType = (e) => {
    const value = e?.target?.value;

    setValue("bankId", value);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} textAlign="right">
          <Typography variant="label"> نام بانک</Typography>

          <Select
            items={bankDataForm}
            value={watch("bankId")}
            itemText="name"
            itemValue="id"
            onChange={handleChangeType}
            dir="rtl"
          />
        </Grid>

        <Grid item xs={12} textAlign="right">
          <Typography variant="label">نام صاحب حساب</Typography>

          <TextField
            rowsMin={1}
            placeholder="نام صاحب حساب را وارد کنید"
            {...register("accountOwnerName")}
            error={!!errors?.accountOwnerName}
          />
        </Grid>

        <Grid item xs={12} textAlign="right">
          <Typography variant="label">شماره حساب</Typography>

          <TextField
            placeholder="شماره حساب  را وارد کنید"
            rowsMin={1}
            error={!!errors?.accNumbers}
            {...register("accountNumber")}
          />
        </Grid>

        <Grid item xs={12} textAlign="right">
          <Typography variant="label">شماره شبا</Typography>

          <TextField
            rowsMin={1}
            error={!!errors?.shabaNumber}
            {...register("shabaNumber")}
            InputProps={{
              inputComponent: TextMask,
              inputProps: {
                mask: SHEBA_MASK,
                placeholder: "شماره شبا را وارد کنید",
              },
            }}
          />
        </Grid>

        <Grid item xs={12} textAlign="right">
          <Typography variant="label">شماره کارت</Typography>

          <TextField
            variant="outlined"
            {...register("cardNumber")}
            rowsMin={1}
            error={!!errors?.cardNumber}
            InputProps={{
              inputComponent: TextMask,
              inputProps: {
                mask: CREDIT_CARD_MASK,
                placeholder: "شماره کارت را وارد کنید",
              },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Button color="info" fullWidth onClick={onClose}>
            انصراف
          </Button>
        </Grid>

        <Grid item xs={6}>
          <LoadingButton
            variant="contained"
            loading={loading}
            fullWidth
            color={actionButtonBg(theme)}
            type="submit"
          >
            {isEdit ? "ویرایش" : "ثبت"}
          </LoadingButton>
        </Grid>
      </Grid>
    </form>
  );
}

export default AddEditBankAccountForm;
